// "Cine poate participa?" cards become a Swiper carousel at <=1120px.
// The same markup is a plain CSS grid above that (see _participation-grid.scss) —
// Swiper is instantiated/destroyed as the viewport crosses the 1120px
// breakpoint so it never touches the grid layout.
// Slides per view: 3 (921-1120px), 2 (501-920px), fixed 305px cards in free mode (<=500px).
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';

$(function () {
    const el = document.querySelector('[data-participation-swiper]');

    if (!el) {
        return;
    }

    const mediaQuery = window.matchMedia('(max-width: 1120px)');
    let swiper = null;

    const enable = () => {
        if (swiper) {
            return;
        }

        swiper = new Swiper(el, {
            modules: [Navigation, FreeMode],
            // <=500px: 'auto' takes the fixed 305px card width from CSS
            // (_participation-grid.scss) so Swiper measures the real edges.
            slidesPerView: 'auto',
            spaceBetween: 16,
            // Free (momentum) scrolling on phones only (<=500px).
            freeMode: { enabled: true },
            // Swiper breakpoints are min-width (>=).
            breakpoints: {
                501: { slidesPerView: 2, freeMode: { enabled: false } },
                921: { slidesPerView: 3, freeMode: { enabled: false } },
            },
            navigation: {
                nextEl: '[data-participation-next]',
                prevEl: '[data-participation-prev]',
            },
        });
    };

    const disable = () => {
        if (!swiper) {
            return;
        }

        swiper.destroy(true, true);
        swiper = null;
    };

    const sync = () => (mediaQuery.matches ? enable() : disable());

    sync();
    mediaQuery.addEventListener('change', sync);
});
